import { render, staticRenderFns } from "./BrandLogoTextboxAnglais.vue?vue&type=template&id=80923c06&"
import script from "./BrandLogoTextboxAnglais.vue?vue&type=script&lang=js&"
export * from "./BrandLogoTextboxAnglais.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports